import type { RootfiEnvironment } from '../types/rootfiLink';

/** Matches `NEXT_PUBLIC_ROOTFI_API_VERSION` contract. */
export const ROOT_FI_SDK_SCRIPT_VERSION_V3 = 'v3' as const;
export const ROOT_FI_SDK_SCRIPT_VERSION_V4 = 'v4' as const;

export const ROOT_FI_SDK_RESOLVED_SCRIPT_VERSION =
  process.env.NEXT_PUBLIC_ROOTFI_API_VERSION || ROOT_FI_SDK_SCRIPT_VERSION_V3;

export const ROOT_FI_SDK_LOADER_URL_V3: Record<RootfiEnvironment, string> = {
  dev: 'http://localhost:3000/sdk.dev.js',
  staging: 'https://sdk.dev.rootfi.dev/sdk.staging.js',
  global: 'https://sdk.rootfi.dev/sdk.js',
};

export const ROOT_FI_SDK_LOADER_URL_V4: Record<RootfiEnvironment, string> = {
  dev: 'http://localhost:3000/sdk-v4.dev.js',
  staging: 'https://sdk.integrations.staging.commenda.io/sdk-v4.staging.js',
  global: 'https://sdk.integrations.commenda.io/sdk-v4.js',
};

export function resolveRootFiSdkLoaderScriptUrl(
  environment: RootfiEnvironment
): string {
  const urls =
    ROOT_FI_SDK_RESOLVED_SCRIPT_VERSION === ROOT_FI_SDK_SCRIPT_VERSION_V4
      ? ROOT_FI_SDK_LOADER_URL_V4
      : ROOT_FI_SDK_LOADER_URL_V3;
  return urls[environment];
}
